import { PureComponent, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { setIsPageBlocked } from '../../App';
import GenieConfiguration, { CUSTOM_ENTITY, ItemId } from './GenieConfiguration';
import ListGenieItems from './ListGenieItems';
import { connect } from 'react-redux';
import { GlobalState } from '../../store/reducers';
import { getSectionNameConfig } from '../../store/selectors/session';
import { GeniePadElementsSettingItem } from '../../api/pushGenie';
import { SectionNameConfig } from '../../store/db';
import { getSectionNameFromKey } from '../utils';
import GenieCustomSection from './GenieCustomSection';

type Props = {
    itemId: ItemId;
    name: string;
    url: string;
    sectionNameConfig?: SectionNameConfig;
};

class GenieConfigure extends PureComponent<Props> {
    render(): ReactNode {
        const { itemId, name, url, sectionNameConfig } = this.props;

        return (
            <div className="h-full flex flex-col relative">
                <div className="flex pl-16 space-x-4 border-b border-darwin-neutral-200 bg-darwin-neutral_new-50 overflow-auto">
                    {GenieConfiguration.configs.map((i) => (
                        <Link to={`${url}/${i.id}/all`} onClick={() => setIsPageBlocked(true)}>
                            <div
                                className={`flex items-center space-x-8 px-16 pt-12 pb-8 ${
                                    i.id === itemId
                                        ? 'border-b-2 border-darwin-accent-bright-blue-800 font-700 text-darwin-accent-bright-blue-800'
                                        : 'font-700 text-darwin-neutral-900'
                                }`}
                            >
                                {/* <div>
                                    {i.icon(
                                        i.id === itemId
                                            ? 'fill-darwin-accent-bright-blue-800'
                                            : 'fill-darwin-neutral-600',
                                    )}
                                </div> */}
                                <p className="whitespace-nowrap">
                                    {getSectionNameFromKey(i.id, sectionNameConfig) || i.name}
                                </p>
                            </div>
                        </Link>
                    ))}
                </div>
                {itemId === CUSTOM_ENTITY ? (
                    <div className="flex-1 overflow-scroll">
                        <GenieCustomSection />
                    </div>
                ) : (
                    <div className="flex-1 overflow-scroll">
                        <ListGenieItems
                            itemId={itemId}
                            name={getSectionNameFromKey(itemId, sectionNameConfig) || name}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default connect((state: GlobalState) => ({
    sectionNameConfig: getSectionNameConfig(state),
}))(GenieConfigure);
